export const mutations = {
  setErrors (state, error) {
    state.errors = error
  },
  unsetErrors (state) {
    state.errors = null
  }
}
